
export default {
  memberInfoNice: { // 나이스 본인인증 팝업창 호출
    method: 'POST',
    url: 'mrm/v1/ignore/nrw/memberInfoNice'
  },
  memberNiceCall: { // 나이스 본인인증 팝업창 호출 (sEncData만 생성해서 리턴해주는 방식)
    method: 'GET',
    url: 'mrm/v1/ignore/nrw/memberNiceCall'
  },
  updatePswdChgExt: { // 나중에보기 업데이트
    method: 'POST',
    url: 'mrm/v1/permit/nrw/member/pswdChgExt'
  },
  releaseMember: { // 비밀번호 5회 잠김 해제
    method: 'POST',
    url: 'mrm//v1/permit/nrw/member/releaseMember'
  }
}



// WEBPACK FOOTER //
// ./src/config/router/nrw/api/memberApi.js